/**
===================================================
Module: frontend.src.stores.sessionCreationStore.ts
Description: Zustand store for managing session creation state
Owner: Kawada Technosystem Co Ltd
All Rights Reserved
This script is proprietary and confidential.
Unauthorized copying, distribution, or modification of this
file, via any medium, is strictly prohibited.
===================================================
*/

import { create } from "zustand";
import { CreateSessionRequest } from "../types";

interface SessionCreationState {
  sessionData: CreateSessionRequest | null;
  pdfFile: File | null;
  thumbnailBlob: Blob | null;
  isGeneratingThumbnail: boolean;
  setSessionData: (data: CreateSessionRequest | null) => void;
  setPdfFile: (file: File | null) => void;
  setThumbnailBlob: (blob: Blob | null) => void;
  setIsGeneratingThumbnail: (isGenerating: boolean) => void;
  clearState: () => void;
  resetState: () => void;
}

export const useSessionCreationStore = create<SessionCreationState>((set) => ({
  sessionData: null,
  pdfFile: null,
  thumbnailBlob: null,
  isGeneratingThumbnail: false,
  
  setSessionData: (data) => set({ sessionData: data }),
  setPdfFile: (file) => set({ pdfFile: file }),
  setThumbnailBlob: (blob) => set({ thumbnailBlob: blob }),
  setIsGeneratingThumbnail: (isGenerating) => set({ isGeneratingThumbnail: isGenerating }),
  
  clearState: () => set({
    sessionData: null,
    pdfFile: null,
    thumbnailBlob: null,
    isGeneratingThumbnail: false,
  }),
  
  resetState: () => set({
    sessionData: null,
    pdfFile: null,
    thumbnailBlob: null,
    isGeneratingThumbnail: false,
  }),
}));
